import React from 'react';
import { useBacklogSelector } from '../../state';
import { getCardIds } from '../../state/selectors/cards';
import FieldSync from './field-sync';

const AllFieldsSync = () => {
	const cardIds = useBacklogSelector(getCardIds);
	return (
		<>
			{cardIds.map((id) => (
				<FieldSync key={id} cardId={id} />
			))}
		</>
	);
};

export default AllFieldsSync;
